'use client';

import { cn } from '@baseball-near-you/ui';
import type { FiftyFifty as IFiftyFifty } from '@bb/sanity.types';
import { SanityLinkButton } from '../SanityButton';
import { SanityImageComponent } from '../SanityImageComponent';
import { Pretitle, SanityWrapper, Title } from '../SanityWrapper';
import { renderPortableText } from '../renderPortableText';

export function FiftyFifty({ block }: { block: IFiftyFifty }) {
  return (
    <SanityWrapper>
      <div
        className={cn(
          'flex h-full w-full flex-col-reverse justify-between gap-y-5 md:flex-row md:gap-x-5 md:gap-y-0',
          block.imageOnLeft ? 'md:flex-row-reverse' : 'md:flex-row',
          block.imageOverlap && 'md:relative'
        )}
      >
        <div
          className={cn(
            'flex flex-col justify-center text-center md:w-1/2 md:text-left',
            block.imageOverlap &&
              'z-10 h-min self-center rounded-lg border bg-white p-5 shadow-md md:absolute'
          )}
        >
          {!!block.pretitle && <Pretitle pretitle={block.pretitle} />}
          {!!block.title && <Title className="" title={block.title} />}
          <div
            style={{
              textWrap: 'balance',
            }}
          >
            {block.body && renderPortableText(block.body)}
          </div>
          {block.buttons && block.buttons?.length > 0 && (
            <div
              className={
                'mt-8 grid grid-flow-row grid-rows-2 gap-x-5 gap-y-3 md:grid-flow-col md:grid-cols-2 md:grid-rows-1 md:gap-y-0'
              }
            >
              {block.buttons?.map((button, i) => (
                <SanityLinkButton key={button._key} button={button} />
              ))}
            </div>
          )}
        </div>
        <div
          className={cn(
            'relative mt-4 flex aspect-video h-full items-center justify-center overflow-hidden rounded-md md:mt-0 md:w-1/2',
            block.imageOverlap && 'md:ml-auto md:w-3/5'
          )}
        >
          <SanityImageComponent
            value={block.image}
            fill={{
              objectFit: 'cover',
              objectPosition: block.imageOnLeft ? 'left' : 'right',
            }}
          />
        </div>
      </div>
    </SanityWrapper>
  );
}
